module.exports = __webpack_public_path__ + "static/media/dep3.79f1e819.jpg";